module.exports = __webpack_public_path__ + "img/2.23692353.jpg";